import { render } from "./AnswerSheet.vue?vue&type=template&id=7035e6e8&ts=true"
import script from "./AnswerSheet.vue?vue&type=script&lang=ts"
export * from "./AnswerSheet.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__